<template>
  <div class="container">
    <generic-table
      ref="datatable"
      :title="$t('users')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/access/user/datatables"
      :page_length="25"
      mode="table"
      grid_class="is-col-min-11"
    >
      <template #item="item">
        <div class="card">
          <div class="card-content">
            <div
              class="dropdown is-pulled-right is-right"
              :data-uuid="item.uuid"
              @mouseover="show_menu(item)"
              @mouseleave="hide_menu(item)"
            >
              <div class="dropdown-trigger">
                <div
                  class="tag"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                  :data-tooltip="$t('options')"
                >
                  <span class="icon is-small has-text-primary">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="dropdown-menu options-menu" role="menu">
                <div class="dropdown-content">
                  <a
                    class="dropdown-item"
                    @click="disable(item)"
                    v-if="item.status_code != 'D'"
                  >
                    <span class="icon has-text-danger">
                      <i class="fa fa-ban"></i>
                    </span>
                    <span>{{ $t("disable") }}</span>
                  </a>
                  <a
                    class="dropdown-item"
                    @click="activate(item)"
                    v-if="item.status_code == 'D'"
                  >
                    <span class="icon has-text-success">
                      <i class="fa fa-bolt"></i>
                    </span>
                    <span>{{ $t("activate") }}</span>
                  </a>
                  <a
                    class="dropdown-item"
                    @click="remove(item)"
                    v-if="item.status_code == 'D'"
                  >
                    <span class="icon has-text-danger">
                      <i class="fa fa-trash"></i>
                    </span>
                    <span>{{ $t("delete") }}</span>
                  </a>
                  <a class="dropdown-item" @click="edit(item)">
                    <span class="icon has-text-warning">
                      <i class="fa fa-edit"></i>
                    </span>
                    <span>{{ $t("edit") }}</span>
                  </a>
                  <a class="dropdown-item" @click="toggle_developer(item)">
                    <span class="icon has-text-info">
                      <i class="fa fa-code"></i>
                    </span>
                    <span>{{ $t("toggle developer mode") }}</span>
                  </a>
                  <a class="dropdown-item" @click="update_password(item)">
                    <span class="icon has-text-warning">
                      <i class="fa fa-key"></i>
                    </span>
                    <span>{{ $t("update password") }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="media mb-0">
              <div class="media-left">
                <figure
                  class="image is-48x48 m-auto py-3"
                  v-if="
                    item.photo &&
                    item.photo.settings &&
                    item.photo.settings.final_name
                  "
                >
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${item.photo.settings.final_name}`"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                </figure>
                <figure class="image is-48x48" v-else>
                  <img
                    src="https://cdn.icon-icons.com/icons2/2468/PNG/512/user_icon_149329.png"
                  />
                </figure>
              </div>
              <div class="media-content">
                <div class="title is-5">
                  <span>{{ item.username }}</span>
                </div>
                <p class="subtitle is-6 mb-0">{{ item.email }}</p>
                <div class="subtitle">
                  <div class="tags mb-1 mt-2">
                    <span class="tag is-primary" v-if="item.status_code == 'A'">
                      <span class="icon">
                        <i class="fa fa-check"></i>
                      </span>
                      <span>{{ $t("active") }}</span>
                    </span>
                    <span class="tag is-danger" v-if="item.status_code == 'D'">
                      <span class="icon">
                        <i class="fa fa-ban"></i>
                      </span>
                      <span>{{ $t("disabled") }}</span>
                    </span>
                    <span class="tag is-info" v-if="item.is_developer">
                      <span class="icon">
                        <i class="fa fa-code"></i>
                      </span>
                      <span>{{ $t("developer") }}</span>
                    </span>
                  </div>
                </div>
                <div class="tags">
                  <span
                    class="tag is-warning"
                    v-show="
                      !item.system_role_suscriptions ||
                      item.system_role_suscriptions.length == 0
                    "
                  >
                    <span class="icon">
                      <i class="fa fa-exclamation-triangle"></i>
                    </span>
                    <span>{{ $t("not suscribed to any role") }}</span>
                  </span>
                  <span
                    class="tag is-info is-light"
                    v-show="
                      item.system_role_suscriptions &&
                      item.system_role_suscriptions.length
                    "
                    v-for="(suscription, sidx) in item.system_role_suscriptions"
                  >
                    <span class="icon">
                      <i class="fa fa-check"></i>
                    </span>
                    <span>{{ suscription.role.name }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="content">
              <!-- <span class="title is-6">{{ $t("roles") }}</span> -->

              <!-- <div>{{ format_date_time(item.create_date) }}</div> -->
              <!-- <pre>{{ item }}</pre> -->
            </div>
          </div>
        </div>
        <!-- <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <figure class="image is-64x64 m-auto" @click="file_list(item)">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3767/3767084.png"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="file_list(item)">
            <div class="media">
              <div class="media-content">
                <p class="title is-6 has-text-centered">
                  {{ item.username }}
                </p>
                <div class="subtitle is-6 has-text-centered">
                  {{ item.email }}
                </div>
                <div>
                  <pre>{{ item }}</pre>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div> -->
      </template>
    </generic-table>

    <create-modal ref="create_modal" @success="refresh" />
    <edit-modal ref="edit_modal" @success="refresh" />
    <update-password-modal ref="update_password_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import { generate_datatables_button } from "@/utils";
import CreateModal from "./create_modal/Index.vue";
import EditModal from "./edit_modal/Index.vue";
import UpdatePasswordModal from "./update_password_modal/Index.vue";
import {
  // session_token,
  api_host,
  // register_listener,
  confirm_deletion_dialog,
  confirm_activation_dialog,
  del,
  post,
  error_message,
  format_date_time,
  success_message,
} from "@/utils";
import VLazyImage from "v-lazy-image";

// console.log("register_listener", register_listener);

export default {
  name: "AccessUsers",
  components: {
    CreateModal,
    EditModal,
    UpdatePasswordModal,
    GenericTable,
    VLazyImage,
  },
  computed: {
    api_host() {
      return api_host;
    },
  },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
        {
          text: v.$t("purge photos"),
          icon: "fa fa-stethoscope",
          class: "is-secondary is-rounded",
          click: this.purge_photos,
        },
      ],
      columns: [
        {
          title: v.$t("username"),
          name: "username",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let icon = "";
            if (row.status_code && ["A"].includes(row.status_code))
              icon = `<span class="icon has-text-success" data-tooltip="${v.$t(
                "is active"
              )}">
                        <i class="fa fa-check"></i>
                      </span>`;
            else if (row.status_code && ["D"].includes(row.status_code))
              icon = `<span class="icon has-text-danger" data-tooltip="${v.$t(
                "is disabled"
              )}">
                        <i class="fa fa-ban"></i>
                      </span>`;
            else icon = row.status_code || "";

            let icon_developer = "";
            if (row.is_developer)
              icon_developer = `<span class="icon has-text-warning" data-tooltip="${v.$t(
                "is developer"
              )}">
                        <i class="fa fa-code"></i>
                      </span><span> ${v.$t("developer")}</span>`;

            let photo_default =
              "https://cdn.icon-icons.com/icons2/2468/PNG/512/user_icon_149329.png";

            if (
              row.photo &&
              row.photo.settings &&
              row.photo.settings.final_name
            )
              photo_default = `${api_host}/drive/static/${row.photo.settings.final_name}`;

            /** New design */
            return `
  <div class="card-content py-3">
    <div class="media">
      <div class="media-left">
        <figure class="image is-48x48" style="margin-right: 0.5rem;">
          <img 
            src="${photo_default}" 
            style="width:48px; height:48px; object-fit:cover; border-radius:10px; border:1.5px solid #eee; background:#fafbfc;"
          />
        </figure>
      </div>
      <div class="media-content">
        <div class="is-flex is-align-items-center mb-1">
          ${icon}
          <span class="title is-6 ml-1">${row.username}</span>          
        </div>
        <p class="subtitle is-6 mb-0" style="color:#666;">${row.email}</p>
        ${
          row.is_developer
            ? `<div class="tag is-small mt-2">
                  <span class="icon"><i class="fa fa-code has-text-warning"></i></span>
                  <span>${v.$t("developer")}</span>
                </div>`
            : ""
        }
      </div>
    </div>
  </div>
`;

            // return `${icon} ${icon_developer} ${row.username || ""}`;
          },
        },
        // {
        //   title: v.$t("email"),
        //   name: "email",
        //   data: (row) => {
        //     return row.email || "";
        //   },
        // },
        {
          title: v.$t("roles"),
          searchable: false,
          name: "roles",
          data: (row) => {
            let roles_name = row.system_role_suscriptions
              .map((role) => role.role.name)
              .join(", ");
            return roles_name;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let r = `<p class="buttons">`;
            if (!["D"].includes(row.status_code))
              r += generate_datatables_button({
                args: { uuid: row.uuid },
                tooltip: v.$t("disable"),
                icon: "fa fa-ban",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to disable user?"),
                    v,
                    () => {
                      del("/access/user", { uuid: uuid, op: "dis" })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              });
            if (["D"].includes(row.status_code)) {
              r += generate_datatables_button({
                args: { uuid: row.uuid },
                tooltip: v.$t("activate"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-success",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_activation_dialog(
                    v.$t("are you sure to activate user?"),
                    v,
                    () => {
                      post("/access/user/activate", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              });

              r += generate_datatables_button({
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete user?"),
                    v,
                    () => {
                      del("/access/user", { uuid: uuid, op: "del" })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              });
            }

            r += generate_datatables_button({
              args: { uuid: row.uuid },
              tooltip: v.$t("edit"),
              icon: "fa fa-edit",
              icon_class: "is-small",
              click: function (e) {
                let uuid = e.detail.uuid;
                v.$refs.edit_modal.show_modal(uuid);
              },
            });

            r += generate_datatables_button({
              args: { uuid: row.uuid },
              tooltip: v.$t("toggle developer mode"),
              icon: "fa fa-code",
              icon_class: "is-small",
              click: function (e) {
                let uuid = e.detail.uuid;
                post("/access/user/developer", { uuid: uuid })
                  .then(() => {
                    v.refresh();
                  })
                  .catch((error) => {
                    error_message(error);
                  });
              },
            });

            r += generate_datatables_button({
              args: { uuid: row.uuid },
              tooltip: v.$t("update password"),
              icon: "fa fa-key",
              icon_class: "is-small",
              click: function (e) {
                let uuid = e.detail.uuid;
                v.$refs.update_password_modal.show_modal(uuid);
              },
            });

            r = `${r}</p>`;
            return r;
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    create() {
      let v = this;
      v.$refs.create_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    hide_menu(element) {
      let trgt_menu = window.jQuery("[data-uuid='" + element.uuid + "']");
      if (trgt_menu) {
        setTimeout(() => {
          trgt_menu.removeClass("is-active");
        }, 200);
      }
    },
    show_menu(element) {
      let trgt_menu = window.jQuery("[data-uuid='" + element.uuid + "']");
      if (trgt_menu) trgt_menu.addClass("is-active");
    },
    disable(element) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to disable user?"), v, () => {
        del("/access/user", { uuid: element.uuid, op: "dis" })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    activate(element) {
      let v = this;
      confirm_activation_dialog(
        v.$t("are you sure to activate user?"),
        v,
        () => {
          post("/access/user/activate", { uuid: element.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    remove(element) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete user?"), v, () => {
        del("/access/user", { uuid: element.uuid, op: "del" })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    edit(element) {
      let v = this;
      v.$refs.edit_modal.show_modal(element.uuid);
    },
    toggle_developer(element) {
      let v = this;
      post("/access/user/developer", { uuid: element.uuid })
        .then(() => {
          v.refresh();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    update_password(element) {
      let v = this;
      v.$refs.update_password_modal.show_modal(element.uuid);
    },
    purge_photos() {
      let v = this;
      confirm_activation_dialog(
        v.$t("are you sure to purge photos?"),
        v,
        () => {
          post("/access/user/purge-photos", {})
            .then(() => {
              success_message(v.$t("photos purged successfully"));
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
};
</script>

<style></style>
